import { css } from 'styled-components';
import { PopupWrapperProps, PopupProps } from './models';

const centerPercentage = '50%';
const left = centerPercentage;

export const PopupWrapper = css<PopupWrapperProps>(({ theme, centerPosition, fullScreenOnMobile }) => {
  const top = centerPosition ? centerPercentage : '35%';
  const fullScreenMode = fullScreenOnMobile ? '100%' : 'unset';

  return css`
    position: fixed;
    z-index: 9999;
    display: flex;
    height: ${fullScreenMode};
    width: ${fullScreenMode};
    top: ${centerPercentage};
    left: ${centerPercentage};
    transform: translate(-${centerPercentage}, -${centerPercentage});

    @media screen and ${theme.device.laptopS} {
      top: ${top};
      left: ${left};
      transform: translate(-${left}, -${top});
      height: auto;
      width: auto;
    }
  `;
});

export const Popup = css<PopupProps>(({ theme, fullScreenOnMobile }) => {
  return css`
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    border-radius: 0;
    padding: 30px;
    background: ${theme.colors.white};

    @media screen and ${theme.device.laptopS} {
      box-shadow: 0px 4px 12px -4px rgba(22, 34, 51, 0.12), 0px 16px 32px rgba(22, 34, 51, 0.16);
      border-radius: 10px;
      justify-content: space-between;
    }

    @media screen and ${theme.device.max.mobileXL} {
      padding: ${fullScreenOnMobile ? 10 : 30}px;
    }
  `;
});
